export const LiquidateReasonsTreeData = [
  {
    value: 'liquidate-take-profit-cut-loss',
    title: 'Liquidate/Take Profit/Cut loss',
    disabled: true,
    children: [
      {
        value: 'Thesis realized',
        title: 'Thesis realized',
      },
      {
        value: 'Thesis is wrong/Conviction changed',
        title: 'Thesis is wrong/Conviction changed',
      },
      {
        value: 'Thesis unchanged but price moved the other way',
        title: 'Thesis unchanged but price moved the other way',
      },
      {
        value: 'To avoid upcoming event',
        title: 'To avoid upcoming event',
      },
      {
        value: 'Idea becomes too crowded/consensus',
        title: 'Idea becomes too crowded/consensus',
      },
    ],
  },
  {
    value: 'Trading sideways/Stock not moving on earnings/event/catalyst',
    title: 'Trading sideways/Stock not moving on earnings/event/catalyst',
  },
  {
    value: 'Liquidate before holiday/leaves/travelling',
    title: 'Liquidate before holiday/leaves/travelling',
  },
  {
    value: 'Stale (Clean up old ideas)',
    title: 'Stale (Clean up old ideas)',
  },
  {
    value: 'Gross down',
    title: 'Gross down',
    disabled: true,
    children: [
      {
        value: 'Gross down on low conviction on market',
        title: 'Gross down on low conviction on market',
      },
      {
        value: 'Make portfolio more balanced',
        title: 'Make portfolio more balanced',
      },
    ],
  },
  {
    value: 'Switching to a better idea',
    title: 'Switching to a better idea',
  },
  {
    value: 'Closed due to rule/compliance',
    title: 'Closed due to rule/compliance',
  },
]
